import { ACTION_TYPE, REPORT_NAME } from "../../components/constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../redux-toolkit/hooks";
import * as Yup from 'yup';
import { useBulkSaveValueChainCategoryMutation, useGetAllValueChainCategoryMutation, useGetValueChainCategoryByIdMutation, useSaveValueChainCategoryMutation, useUpdateValueChainCategoryMutation } from "../../redux-toolkit/services/allValueChainCategoriesService";
import { useBulkSaveValueChainMutation, useGetAllValueChainsByIdMutation, useSaveValueChainMutation, useUpdateValueChainMutation } from "../../redux-toolkit/services/allValueChainsService";
import { getAllcountryDetail } from "../../redux-toolkit/slices/countrySlice";
import { getFindStateByCountryNameDetail } from "../../redux-toolkit/slices/statesSlice";
import { getAllValueChainList } from "../../redux-toolkit/slices/allValueChainsSlice";
import { getAllValueChainCategoriesList, setValueChainCategories } from "../../redux-toolkit/slices/allValueChainCategorySlice";
import { useBulkSaveAgentMasterMutation, useGetAgentMasterByIdMutation, useGetAllAgentMasterMutation, useSaveAgentMasterMutation, useUpdateAgentMasterMutation } from "../../redux-toolkit/services/allAgentMasterService";
import { getAllAgentMasterList, setAllAgentMaster } from "../../redux-toolkit/slices/allAgentMasterSlice";
import { Modal } from "react-bootstrap";
import { useBulkSaveResponsibilityCenterMutation, useGetResponsibilityCenterByIdMutation, useSaveResponsibilityCenterMutation, useUpdateResponsibilityCenterMutation } from "../../redux-toolkit/services/responsibilityCenterService";
import { useBulkSaveResponsibilityGroupMutation, useFindAllResponsibilityGroupMutation, useGetResponsibilityGroupByIdMutation, useSaveResponsibilityGroupMutation, useUpdateResponsibilityGroupMutation } from "../../redux-toolkit/services/responsibilityGroupService";
import { findAllResGroupDetails, setResGroupAll } from "../../redux-toolkit/slices/responsibilityGroupSlice";
import { useBulkUploadTokenMechanismMastersMutation, useGetTokenMechanismMasterByIdMutation, useSaveTokenMechanismMasterMutation, useUpdateTokenMechanismMasterMutation } from "../../redux-toolkit/services/tokenMechanismMasterService";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useBulkSaveAuditLogMutation, useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
    isCategory?: boolean;
    setIsCategory?: any;
};

const validationSchema = Yup.object().shape({
    percentageCompleted: Yup.number()
        .min(0, 'Percentage must be at least 0')
        .max(100, 'Percentage cannot exceed 100'),
});

const MasterReportData = (props: Props) => {

    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [selectData, setSelectData]: any = useState();

    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");

    //save
    const [saveAgentMaster, saveAgentMasterResponse] = useSaveAgentMasterMutation();
    const [saveValueChain, saveValueChainResponse] = useSaveValueChainMutation();
    const [saveValueChainCategory, saveValueChainCategoryResponse] = useSaveValueChainCategoryMutation();
    const [saveResponsibilityGroup, saveResponsibilityGroupResponse] = useSaveResponsibilityGroupMutation();
    const [saveResponsibilityCenter, saveResponsibilityCenterResponse] = useSaveResponsibilityCenterMutation();
    const [saveTokenMechanismMaster, saveTokenMechanismMasterResponse] = useSaveTokenMechanismMasterMutation();
    const [logAudit] = useSaveAuditLogMutation();
    const [logAuditBulk] = useBulkSaveAuditLogMutation();
    //bulk
    const [bulkSaveResponsibilityGroup, bulkSaveResponsibilityGroupResponse] = useBulkSaveResponsibilityGroupMutation();
    const [bulkSaveResponsibilityCenter, bulkSaveResponsibilityCenterResponse] = useBulkSaveResponsibilityCenterMutation();
    const [bulkSaveAgentMaster, bulkSaveAgentMasterResponse] = useBulkSaveAgentMasterMutation();
    const [bulkSaveValueChain, bulkSaveValueChainResponse] = useBulkSaveValueChainMutation();
    const [bulkSaveValueChainCategory, bulkSaveValueChainCategoryResponse] = useBulkSaveValueChainCategoryMutation();
    const [bulkSaveTokenMechanismMaster, bulkSaveTokenMechanismMasterResponse] = useBulkUploadTokenMechanismMastersMutation();
    //update
    const [updateAgentMaster, updateAgentMasterResponse] = useUpdateAgentMasterMutation();
    const [updateValueChain, updateValueChainResponse] = useUpdateValueChainMutation();
    const [updateValueChainCategory, updateValueChainCategoryResponse] = useUpdateValueChainCategoryMutation();
    const [updateResponsibilityGroup, updateResponsibilityGroupResponse] = useUpdateResponsibilityGroupMutation();
    const [updateResponsibilityCenter, updateResponsibilityCenterResponse] = useUpdateResponsibilityCenterMutation();
    const [updateTokenMechanismMaster, updateTokenMechanismMasterResponse] = useUpdateTokenMechanismMasterMutation();

    //getById mutation
    const [getAgentMasterById, agentMasterByIdResponse] = useGetAgentMasterByIdMutation();
    const [getValueChainsById, valueChainsByIdResponse] = useGetAllValueChainsByIdMutation();
    const [getValueChainCategoriesById, valueChainCategoriesByIdResponse] = useGetValueChainCategoryByIdMutation();
    const [getResponsibilityGroupById, responsibilityGroupByIdResponse] = useGetResponsibilityGroupByIdMutation();
    const [getResponsibilityCenterById, responsibilityCenterByIdResponse] = useGetResponsibilityCenterByIdMutation();
    const [getTokenMechanismMasterById, tokenMechanismMasterByIdResponse] = useGetTokenMechanismMasterByIdMutation();

    //getData
    const [getAllAgentMaster, getAllAgentMasterResponse] = useGetAllAgentMasterMutation();
    const [getValueChainCategories, valueChainCategoriesResponse] = useGetAllValueChainCategoryMutation();
    const [findAllResponsibilityGroup, findAllResponsibilityGroupResponse] = useFindAllResponsibilityGroupMutation();

    //Data

    const allValueChainCategories: any = useAppSelector(getAllValueChainCategoriesList);
    const allCountries: any = useAppSelector(getAllcountryDetail);
    const allStates: any = useAppSelector(getFindStateByCountryNameDetail);
    const allResponsibilityGroups = useAppSelector(findAllResGroupDetails);
    console.log(allResponsibilityGroups, "allResponsibilityGroups");

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.AGENT_MASTER) {
                getAgentMasterById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                getValueChainCategoriesById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                getValueChainCategories({ token: localUserObj?.token });
                getValueChainsById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
                getResponsibilityGroupById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
                findAllResponsibilityGroup({ token: localUserObj?.token, });
                getResponsibilityCenterById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            }
            else if (props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
                getTokenMechanismMasterById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            }

        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                getAllAgentMaster({ token: localUserObj?.token, });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                getAllAgentMaster({ token: localUserObj?.token, });
                getValueChainCategories({ token: localUserObj?.token, });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
                findAllResponsibilityGroup({ token: localUserObj?.token, });
            }
        }
    }, [props.reportName]);

    useEffect(() => {
        if (valueChainCategoriesResponse.isSuccess) {
            dispatch(setValueChainCategories(valueChainCategoriesResponse));
        } else if (valueChainCategoriesResponse.isError) {
            let response: any = valueChainCategoriesResponse.error;
            alertMessage(response, "error");
        }
    }, [valueChainCategoriesResponse.isSuccess, valueChainCategoriesResponse.isError]);

    useEffect(() => {
        if (agentMasterByIdResponse.isSuccess) {
            setGetByIdData(agentMasterByIdResponse.data);
        } else if (agentMasterByIdResponse.isError) {
            let response: any = agentMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [agentMasterByIdResponse.isSuccess, agentMasterByIdResponse.isError]);

    useEffect(() => {
        if (valueChainsByIdResponse.isSuccess) {
            setGetByIdData(valueChainsByIdResponse.data);
        } else if (valueChainsByIdResponse.isError) {
            let response: any = valueChainsByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [valueChainsByIdResponse.isSuccess, valueChainsByIdResponse.isError]);

    useEffect(() => {
        if (valueChainCategoriesByIdResponse.isSuccess) {
            setGetByIdData(valueChainCategoriesByIdResponse.data);
        } else if (valueChainCategoriesByIdResponse.isError) {
            let response: any = valueChainCategoriesByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [valueChainCategoriesByIdResponse.isSuccess, valueChainCategoriesByIdResponse.isError]);

    useEffect(() => {
        if (responsibilityGroupByIdResponse.isSuccess) {
            setGetByIdData(responsibilityGroupByIdResponse.data);
        } else if (responsibilityGroupByIdResponse.isError) {
            let response: any = responsibilityGroupByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [responsibilityGroupByIdResponse.isSuccess, responsibilityGroupByIdResponse.isError]);

    useEffect(() => {
        if (responsibilityCenterByIdResponse.isSuccess) {
            setGetByIdData(responsibilityCenterByIdResponse.data);
        } else if (responsibilityCenterByIdResponse.isError) {
            let response: any = responsibilityCenterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [responsibilityCenterByIdResponse.isSuccess, responsibilityCenterByIdResponse.isError]);

    useEffect(() => {
        if (tokenMechanismMasterByIdResponse.isSuccess) {
            setGetByIdData(tokenMechanismMasterByIdResponse.data);
        } else if (tokenMechanismMasterByIdResponse.isError) {
            let response: any = tokenMechanismMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [tokenMechanismMasterByIdResponse.isSuccess, tokenMechanismMasterByIdResponse.isError]);


    const handleClose = () => {
        props.setShow(false);
    };

    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.AGENT_MASTER) {
                const payload = {
                    agentCode: values.agentCode,
                    agentName: values.agentName,
                    role: values.role,
                    associatedReligion: values.associatedReligion,
                    attributes: values.attributes
                        ? values.attributes.split(",").map((attr: string) => attr.trim())
                        : [],
                    weightage: values.weightage,
                    tokenInfluenceRuleId: values.tokenInfluenceRuleId,
                    assessmentFunction: values.assessmentFunction,
                    approvalAuthority: values.approvalAuthority,
                    parentAgentCode: values.parentAgentCode,
                    isActive: true
                };

                saveAgentMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                saveValueChainCategory({
                    token: localUserObj?.token,
                    payload: {
                        isActive: true,
                        categoryName: values.name,
                        description: values.description,
                        dependentValueChainCategoryCode: values.dependentValueChainCategoryCode
                    },
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                saveValueChain({
                    token: localUserObj?.token,
                    payload: {
                        isActive: true,
                        valueChainCategoryId: values.select,
                        valueChainName: values.name,
                        parameters: values.parameters,
                        dependentValueChainCode: values.dependentValueChainCode
                    },
                });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
                saveResponsibilityGroup({
                    token: localUserObj?.token,
                    payload: {
                        isActive: true,
                        groupName: values.groupName,
                        description: values.description,
                        religion: values.religion,
                        dependentRespGroupCode: values.dependentRespGroupCode
                    },
                });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
                saveResponsibilityCenter({
                    token: localUserObj?.token,
                    payload: {
                        isActive: true,
                        resCenterName: values.resCenterName,
                        resCenterDesc: values.description,
                        respGroupId: values.select,
                        dependentRespCenterCode: values.dependentRespCenterCode
                    },
                });
            }

            else if (props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
                saveTokenMechanismMaster({
                    token: localUserObj?.token,
                    payload: {
                        description: values.description,
                        effectiveFromDate: values.effectiveFromDate,
                        effectiveToDate: values.effectiveToDate,
                        multiplier: values.multiplier,
                        currencyUnit: values.currencyUnit,
                        isActive: values.isActive
                    }
                });


            }
        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.AGENT_MASTER) {
                const payload = {
                    isActive: props.data.isActive,
                    id: props.data.id,
                    agentCode: values.agentCode,
                    agentName: values.agentName,
                    role: values.role,
                    associatedReligion: values.associatedReligion,
                    attributes: Array.isArray(values.attributes)
                        ? values.attributes
                        : values.attributes
                            ? values.attributes.split(",").map((attr: string) => attr.trim())
                            : [],
                    weightage: values.weightage,
                    tokenInfluenceRuleId: values.tokenInfluenceRuleId,
                    assessmentFunction: values.assessmentFunction,
                    approvalAuthority: values.approvalAuthority,
                    parentAgentCode: values.parentAgentCode
                };

                updateAgentMaster({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: payload
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                updateValueChainCategory({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: {
                        isActive: props.data.isActive,
                        id: props?.data?.id,
                        categoryName: values.name,
                        description: values.description,
                        dependentValueChainCategoryCode: values.dependentValueChainCategoryCode
                    },
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                updateValueChain({
                    token: localUserObj?.token,
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        valueChainCategoryId: values.select,
                        valueChainName: values.name,
                        parameters: values.parameters,
                        dependentValueChainCode: values.dependentValueChainCode
                    },
                });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
                updateResponsibilityGroup({
                    token: localUserObj?.token,
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        groupName: values.groupName,
                        description: values.description,
                        religion: values.religion,
                        dependentRespGroupCode: values.dependentRespGroupCode
                    },
                });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
                updateResponsibilityCenter({
                    token: localUserObj?.token,
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        resCenterName: values.resCenterName,
                        resCenterDesc: values.description,
                        dependentRespCenterCode: values.dependentRespCenterCode,
                        resGroupId: values.select,
                    },
                });
            }
            else if (props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
                updateTokenMechanismMaster({
                    token: localUserObj?.token,
                    payload: {
                        id: values.id,
                        description: values.description,
                        effectiveFromDate: values.effectiveFromDate,
                        effectiveToDate: values.effectiveToDate,
                        multiplier: values.multiplier,
                        currencyUnit: values.currencyUnit,
                        isActive: values.isActive
                    },
                });
            }
        }
    };

    // ========== SAVE AGENT MASTER ==========
    useEffect(() => {
        if (saveAgentMasterResponse.isSuccess) {
            const response: any = saveAgentMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.AGENT_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Agent Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveAgentMasterResponse.isError) {
            let response: any = saveAgentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveAgentMasterResponse.isSuccess, saveAgentMasterResponse.isError]);

    // ========== UPDATE AGENT MASTER ==========
    useEffect(() => {
        if (updateAgentMasterResponse.isSuccess) {
            const response: any = updateAgentMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.AGENT_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: agentMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Agent Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateAgentMasterResponse.isError) {
            let response: any = updateAgentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateAgentMasterResponse.isSuccess, updateAgentMasterResponse.isError]);

    // ========== SAVE VALUE CHAIN ==========
    useEffect(() => {
        if (saveValueChainResponse.isSuccess) {
            const response: any = saveValueChainResponse.data;

            const payload = {
                tableName: REPORT_NAME.VALUE_CHAIN,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Value Chain added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveValueChainResponse.isError) {
            let response: any = saveValueChainResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveValueChainResponse.isSuccess, saveValueChainResponse.isError]);

    // ========== UPDATE VALUE CHAIN ==========
    useEffect(() => {
        if (updateValueChainResponse.isSuccess) {
            const response: any = updateValueChainResponse.data;

            const payload = {
                tableName: REPORT_NAME.VALUE_CHAIN,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: valueChainsByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Value Chain updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateValueChainResponse.isError) {
            let response: any = updateValueChainResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateValueChainResponse.isSuccess, updateValueChainResponse.isError]);

    // ========== SAVE VALUE CHAIN CATEGORY ==========
    useEffect(() => {
        if (saveValueChainCategoryResponse.isSuccess) {
            const response: any = saveValueChainCategoryResponse.data;

            const payload = {
                tableName: REPORT_NAME.VALUE_CHAIN_CATEGORY,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Value Chain Category added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveValueChainCategoryResponse.isError) {
            let response: any = saveValueChainCategoryResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveValueChainCategoryResponse.isSuccess, saveValueChainCategoryResponse.isError]);

    useEffect(() => {
        if (updateValueChainCategoryResponse.isSuccess) {
            const response: any = updateValueChainCategoryResponse.data;

            const payload = {
                tableName: REPORT_NAME.VALUE_CHAIN_CATEGORY,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: valueChainCategoriesByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Value Chain Category updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateValueChainCategoryResponse.isError) {
            let response: any = updateValueChainCategoryResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateValueChainCategoryResponse.isSuccess, updateValueChainCategoryResponse.isError]);

    useEffect(() => {
        if (saveResponsibilityGroupResponse.isSuccess) {
            const response: any = saveResponsibilityGroupResponse.data;

            const payload = {
                tableName: REPORT_NAME.RESPONSIBILITY_GROUP,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Responsibility Group added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveResponsibilityGroupResponse.isError) {
            let response: any = saveResponsibilityGroupResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveResponsibilityGroupResponse.isSuccess, saveResponsibilityGroupResponse.isError]);

    useEffect(() => {
        if (updateResponsibilityGroupResponse.isSuccess) {
            const response: any = updateResponsibilityGroupResponse.data;

            const payload = {
                tableName: REPORT_NAME.RESPONSIBILITY_GROUP,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: responsibilityGroupByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Responsibility Group updated successfully", "success");
            props.setCall("Y");
            props.setIsCategory(true);
            handleClose();
        } else if (updateResponsibilityGroupResponse.isError) {
            let response: any = updateResponsibilityGroupResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateResponsibilityGroupResponse.isSuccess, updateResponsibilityGroupResponse.isError]);

    useEffect(() => {
        if (saveResponsibilityCenterResponse.isSuccess) {
            const response: any = saveResponsibilityCenterResponse.data;

            const payload = {
                tableName: REPORT_NAME.RESPONSIBILITY_CENTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Responsibility Center added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveResponsibilityCenterResponse.isError) {
            let response: any = saveResponsibilityCenterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveResponsibilityCenterResponse.isSuccess, saveResponsibilityCenterResponse.isError]);

    useEffect(() => {
        if (updateResponsibilityCenterResponse.isSuccess) {
            const response: any = updateResponsibilityCenterResponse.data;

            const payload = {
                tableName: REPORT_NAME.RESPONSIBILITY_CENTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: responsibilityCenterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Responsibility Center updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateResponsibilityCenterResponse.isError) {
            let response: any = updateResponsibilityCenterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateResponsibilityCenterResponse.isSuccess, updateResponsibilityCenterResponse.isError]);

    useEffect(() => {
        if (saveTokenMechanismMasterResponse.isSuccess) {
            const response: any = saveTokenMechanismMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.TOKEN_MECHANISM_MASTER,
                recordId: response?.id,
                operationType: "SAVE",
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Token Mechanism Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveTokenMechanismMasterResponse.isError) {
            const response: any = saveTokenMechanismMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveTokenMechanismMasterResponse.isSuccess, saveTokenMechanismMasterResponse.isError]);

    useEffect(() => {
        if (updateTokenMechanismMasterResponse.isSuccess) {
            const response: any = updateTokenMechanismMasterResponse.data;

            const payload = {
                tableName: REPORT_NAME.TOKEN_MECHANISM_MASTER,
                recordId: props?.data?.id,
                operationType: "UPDATE",
                oldValue: tokenMechanismMasterByIdResponse?.data,
                newValue: response,
            };

            logAudit({
                token: localUserObj?.token,
                payload,
            });

            alertMessage("Token Mechanism Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateTokenMechanismMasterResponse.isError) {
            const response: any = updateTokenMechanismMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateTokenMechanismMasterResponse.isSuccess, updateTokenMechanismMasterResponse.isError]);


    useEffect(() => {
        if (allValueChainCategories && props.reportName === REPORT_NAME.VALUE_CHAIN) {
            setSelectData(allValueChainCategories);
        }
    }, [allValueChainCategories]);

    useEffect(() => {
        if (allResponsibilityGroups && props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
            setSelectData(allResponsibilityGroups);
        }
    }, [allResponsibilityGroups]);



    useEffect(() => {
        if (getAllAgentMasterResponse.isSuccess) {
            dispatch(setAllAgentMaster(getAllAgentMasterResponse));
        }
        else if (getAllAgentMasterResponse.isError) {
            let response: any = getAllAgentMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllAgentMasterResponse.isSuccess, getAllAgentMasterResponse.isError]);



    useEffect(() => {
        if (findAllResponsibilityGroupResponse.isSuccess) {
            console.log(findAllResponsibilityGroupResponse, "findAllResponsibilityGroupResponse")
            dispatch(setResGroupAll(findAllResponsibilityGroupResponse));
        } else if (findAllResponsibilityGroupResponse.isError) {
            let response: any = findAllResponsibilityGroupResponse.error;
            alertMessage(response, "error");
        }
    }, [findAllResponsibilityGroupResponse.isSuccess, findAllResponsibilityGroupResponse.isError]);




    const handleBulkUpload = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };

    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.AGENT_MASTER) {
                bulkSaveAgentMaster({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                bulkSaveValueChainCategory({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                bulkSaveValueChain({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP) {
                bulkSaveResponsibilityGroup({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER) {
                bulkSaveResponsibilityCenter({
                    token: localUserObj?.token,
                    payload: formData
                });

            } else if (props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER) {
                bulkSaveTokenMechanismMaster({
                    token: localUserObj?.token,
                    payload: formData
                });
            }
        }
    }

    useEffect(() => {
        if (bulkSaveResponsibilityGroupResponse.isSuccess) {
            const response: any = bulkSaveResponsibilityGroupResponse.data;
            const payload = {
                tableName: REPORT_NAME.RESPONSIBILITY_GROUP,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Responsibility Group added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveResponsibilityGroupResponse.isError) {
            let response: any = bulkSaveResponsibilityGroupResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveResponsibilityGroupResponse.isSuccess, bulkSaveResponsibilityGroupResponse.isError]);

    useEffect(() => {
        if (bulkSaveAgentMasterResponse.isSuccess) {
            const response: any = bulkSaveAgentMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.AGENT_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Agent Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveAgentMasterResponse.isError) {
            let response: any = bulkSaveAgentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveAgentMasterResponse.isSuccess, bulkSaveAgentMasterResponse.isError]);


    useEffect(() => {
        if (bulkSaveResponsibilityCenterResponse.isSuccess) {
            const response: any = bulkSaveResponsibilityCenterResponse.data;
            const payload = {
                tableName: REPORT_NAME.RESPONSIBILITY_CENTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Responsibility Center added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveResponsibilityCenterResponse.isError) {
            let response: any = bulkSaveResponsibilityCenterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveResponsibilityCenterResponse.isSuccess, bulkSaveResponsibilityCenterResponse.isError]);


    useEffect(() => {
        if (bulkSaveTokenMechanismMasterResponse.isSuccess) {
            const response: any = bulkSaveTokenMechanismMasterResponse.data;
            const payload = {
                tableName: REPORT_NAME.TOKEN_MECHANISM_MASTER,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Token Mechanism Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveTokenMechanismMasterResponse.isError) {
            const response: any = bulkSaveTokenMechanismMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveTokenMechanismMasterResponse.isSuccess, bulkSaveTokenMechanismMasterResponse.isError]);


    useEffect(() => {
        if (bulkSaveValueChainCategoryResponse.isSuccess) {
            const response: any = bulkSaveValueChainCategoryResponse.data;
            const payload = {
                tableName: REPORT_NAME.VALUE_CHAIN_CATEGORY,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Value chain category added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveValueChainCategoryResponse.isError) {
            let response: any = bulkSaveValueChainCategoryResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveValueChainCategoryResponse.isSuccess, bulkSaveValueChainCategoryResponse.isError]);

    useEffect(() => {
        if (bulkSaveValueChainResponse.isSuccess) {
            const response: any = bulkSaveValueChainResponse.data;
            const payload = {
                tableName: REPORT_NAME.VALUE_CHAIN,
                operationType: "SAVE",
                newValueList: response,
            };

            logAuditBulk({
                token: localUserObj?.token,
                payload,
            });
            alertMessage("Value chain added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveValueChainResponse.isError) {
            let response: any = bulkSaveValueChainResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveValueChainResponse.isSuccess, bulkSaveValueChainResponse.isError]);




    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" }
                )}

            >
                <Modal.Header closeButton>

                    <Modal.Title
                        className="fw-bold text-accent"
                        style={{ fontSize: "1rem" }}
                    >
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        saveAgentMasterResponse.isLoading ||
                            saveValueChainResponse.isLoading ||
                            saveValueChainCategoryResponse.isLoading ||
                            saveResponsibilityGroupResponse.isLoading ||
                            saveResponsibilityCenterResponse.isLoading ||
                            saveTokenMechanismMasterResponse.isLoading ||

                            bulkSaveResponsibilityGroupResponse.isLoading ||
                            bulkSaveResponsibilityCenterResponse.isLoading ||
                            bulkSaveAgentMasterResponse.isLoading ||
                            bulkSaveValueChainResponse.isLoading ||
                            bulkSaveValueChainCategoryResponse.isLoading ||
                            bulkSaveTokenMechanismMasterResponse.isLoading ||

                            updateAgentMasterResponse.isLoading ||
                            updateValueChainResponse.isLoading ||
                            updateValueChainCategoryResponse.isLoading ||
                            updateResponsibilityGroupResponse.isLoading ||
                            updateResponsibilityCenterResponse.isLoading ||
                            updateTokenMechanismMasterResponse.isLoading ||

                            agentMasterByIdResponse.isLoading ||
                            valueChainsByIdResponse.isLoading ||
                            valueChainCategoriesByIdResponse.isLoading ||
                            responsibilityGroupByIdResponse.isLoading ||
                            responsibilityCenterByIdResponse.isLoading ||
                            tokenMechanismMasterByIdResponse.isLoading ||

                            getAllAgentMasterResponse.isLoading ||
                            valueChainCategoriesResponse.isLoading ||
                            findAllResponsibilityGroupResponse.isLoading
                            ? (
                                <Loading />
                            ) : (
                                ""
                            )
                    }

                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}


                    {activeTab === "manual" && (
                        <Formik
                            validationSchema={validationSchema}
                            validateOnChange={true}
                            validateOnBlur={true}
                            enableReinitialize={true}
                            initialValues={
                                props.reportName === REPORT_NAME.AGENT_MASTER ? {
                                    agentName:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.agentName
                                            : "",
                                    agentCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.agentCode
                                            : "",
                                    role:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.role
                                            : "",
                                    attributes:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.attributes
                                            : "",
                                    associatedReligion:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.associatedReligion
                                            : "",
                                    weightage:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.weightage
                                            : "",
                                    tokenInfluenceRuleId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.tokenInfluenceRuleId
                                            : "",
                                    assessmentFunction:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.assessmentFunction
                                            : "",
                                    approvalAuthority:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.approvalAuthority
                                            : "",
                                    parentAgentCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.parentAgentCode
                                            : "",

                                } : props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ? {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.categoryName
                                            : "",
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.description
                                            : "",
                                    dependentValueChainCategoryCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.dependentValueChainCategoryCode
                                            : "",
                                } : props.reportName === REPORT_NAME.VALUE_CHAIN ? {
                                    select:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.valueChainCategoryId
                                            : "",
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.valueChainName
                                            : "",
                                    parameters:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.parameters
                                            : "",
                                    dependentValueChainCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.dependentValueChainCode
                                            : "",
                                } : props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ? {
                                    groupName:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.groupName
                                            : "",
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.description
                                            : "",
                                    religion:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.religion
                                            : "",
                                    dependentRespGroupCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.dependentRespGroupCode
                                            : "",
                                } : props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ? {
                                    select:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.respGroupId
                                            : "",
                                    resCenterName:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.resCenterName
                                            : "",
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.resCenterDesc
                                            : "",
                                    dependentRespCenterCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.dependentRespCenterCode
                                            : "",
                                } : props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER ? {
                                    id:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.id
                                            : 0,
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.description
                                            : "",
                                    effectiveFromDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.effectiveFromDate
                                            : new Date().toISOString().split("T")[0],
                                    effectiveToDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.effectiveToDate
                                            : new Date().toISOString().split("T")[0],
                                    multiplier:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.multiplier
                                            : 0,
                                    currencyUnit:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.currencyUnit
                                            : "",
                                    isActive:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.isActive
                                            : true,
                                } : props.reportName !== REPORT_NAME.TOKEN_MECHANISM_MASTER ? {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.name ?? ""
                                            : "",
                                } : {}


                            }
                            onSubmit={handleSubmit}
                        >
                            {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => (
                                <Form>
                                    {props.reportName !== REPORT_NAME.TOKEN_MECHANISM_MASTER && (
                                        <div>
                                            <div> <div className="d-flex"> <div> {props.reportName} Name</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                                <input className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={
                                                        props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER
                                                            ? values.resCenterName
                                                            : props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP
                                                                ? values.groupName
                                                                : props.reportName === REPORT_NAME.AGENT_MASTER
                                                                    ? values.agentName
                                                                    : values.name
                                                    }
                                                    name={
                                                        props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER
                                                            ? "resCenterName"
                                                            : props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP
                                                                ? "groupName"
                                                                : props.reportName === REPORT_NAME.AGENT_MASTER
                                                                    ? "agentName"
                                                                    : "name"
                                                    }
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <>
                                        {props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ||
                                            props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ||
                                            props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ?
                                            <div>
                                                <div className="w-100 mt-2">
                                                    <div className="d-flex">
                                                        <div>Description</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.description}
                                                        name="description"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            : null}

                                        {props.reportName === REPORT_NAME.VALUE_CHAIN ?
                                            <div>
                                                <div className="w-100 mt-2">
                                                    <div className="d-flex">
                                                        <div> Value Chain parameters</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.parameters}
                                                        name="parameters"
                                                    />
                                                </div>
                                            </div>
                                            : null}
                                        {props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ?
                                            <div>
                                                <div className="w-100 mt-2">
                                                    <div className="d-flex">
                                                        <div>Relegion</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.religion}
                                                        name="religion"
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            : null}
                                        {props.reportName === REPORT_NAME.VALUE_CHAIN ||
                                            props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ||
                                            props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ||
                                            props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ?
                                            <div>
                                                <div className="w-100 mt-2">
                                                    <div className="d-flex">
                                                        <div>Dependent {props.reportName} Code</div>
                                                    </div>
                                                    <input
                                                        className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={
                                                            props.reportName === REPORT_NAME.VALUE_CHAIN ? values.dependentValueChainCode :
                                                                props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ? values.dependentValueChainCategoryCode :
                                                                    props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ? values.dependentRespGroupCode :
                                                                        props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ? values.dependentRespCenterCode : ""}
                                                        name={props.reportName === REPORT_NAME.VALUE_CHAIN ? "dependentValueChainCode" :
                                                            props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ? "dependentValueChainCategoryCode" :
                                                                props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ? "dependentRespGroupCode" :
                                                                    props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ? "dependentRespCenterCode" : ""}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            : null}
                                        {!props.isCategory && (
                                            props.reportName !== REPORT_NAME.AGENT_MASTER && props.reportName !== REPORT_NAME.TOKEN_MECHANISM_MASTER && (
                                                <div className="w-100 mt-2">
                                                    <div className="d-flex">
                                                        <div>
                                                            Select Category
                                                        </div>
                                                        <div style={{ color: "red" }}>*</div>
                                                    </div>
                                                    <div className="pe-2">
                                                        <select
                                                            className="form-select form-select-sm w-100"
                                                            aria-label=".form-select-sm example"
                                                            name="select"
                                                            value={values.select}
                                                            required
                                                            onChange={(e) => setFieldValue("select", e.target.value)}                                                           >
                                                            <option value="">
                                                                Select Category                                                                </option>
                                                            {selectData &&
                                                                selectData.map((itemType: any, index: any) => {
                                                                    return (
                                                                        <option
                                                                            key={index.toString()}
                                                                            value={itemType.id}
                                                                        >
                                                                            {itemType.id} - {props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ? itemType.groupName : itemType.categoryName}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </select>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </>
                                    {props.reportName === REPORT_NAME.AGENT_MASTER ? (
                                        <div className="w-100 mt-2">
                                            <p>
                                                Agent Code
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.agentCode}
                                                    name="agentCode"
                                                />
                                            </p>
                                            <p>
                                                Role
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.role}
                                                    name="role"
                                                />
                                            </p>
                                            <p>
                                                Attributes
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.attributes}
                                                    name="attributes"
                                                />
                                            </p>
                                            <p>
                                                Weightage
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.weightage}
                                                    name="weightage"
                                                />
                                            </p>
                                            <p>
                                                Token Influence Rule Id
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.tokenInfluenceRuleId}
                                                    name="tokenInfluenceRuleId"
                                                />
                                            </p>
                                            <p>
                                                Associated Religion
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.associatedReligion}
                                                    name="associatedReligion"
                                                />
                                            </p>
                                            <p>
                                                Assessment Function
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.assessmentFunction}
                                                    name="assessmentFunction"
                                                />
                                            </p>
                                            <p>
                                                Approval Authority
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.approvalAuthority}
                                                    name="approvalAuthority"
                                                />
                                            </p>
                                            <p>
                                                Parent Agent Code
                                                <input
                                                    className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.parentAgentCode}
                                                    name="parentAgentCode"
                                                />
                                            </p>
                                        </div>
                                    ) : null}
                                    {props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER ? (
                                        <div className="row g-3">
                                            {/* Left Column */}
                                            <div className="col-12 col-md-6">
                                                {/* Description */}
                                                <label className="form-label">
                                                    Description <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="description"
                                                    value={values.description}
                                                    required
                                                    onChange={(e) => setFieldValue("description", e.target.value)}
                                                />

                                                {/* Multiplier */}
                                                <label className="form-label mt-3">
                                                    Multiplier
                                                </label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="number"
                                                    name="multiplier"
                                                    value={values.multiplier}
                                                    required
                                                    onChange={(e) => setFieldValue("multiplier", e.target.value)}
                                                />

                                                {/* Currency Unit */}
                                                <label className="form-label">
                                                    Currency Unit 
                                                </label>
                                                <input
                                                    className="form-control form-control-sm"
                                                    type="text"
                                                    name="currencyUnit"
                                                    value={values.currencyUnit}
                                                    onChange={(e) => setFieldValue("currencyUnit", e.target.value)}
                                                />
                                            </div>

                                            {/* Right Column */}
                                            <div className="col-12 col-md-6">
                                                {/* Effective From Date */}
                                                <label className="form-label">
                                                    Effective From Date 
                                                </label>
                                                <DatePicker
                                                    className="w-100"
                                                    format="YYYY-MM-DD"
                                                    required
                                                    value={values.effectiveFromDate ? dayjs(values.effectiveFromDate, "YYYY-MM-DD") : null}
                                                    onChange={(date) =>
                                                        setFieldValue("effectiveFromDate", date ? date.format("YYYY-MM-DD") : "")
                                                    }
                                                    getPopupContainer={(trigger) =>
                                                        (trigger.parentNode as HTMLElement) || document.body
                                                    }
                                                />

                                                {/* Effective To Date */}
                                                <label className="form-label mt-3">
                                                    Effective To Date 
                                                </label>
                                                <DatePicker
                                                    className="w-100"
                                                    format="YYYY-MM-DD"
                                                    required
                                                    value={values.effectiveToDate ? dayjs(values.effectiveToDate, "YYYY-MM-DD") : null}
                                                    onChange={(date) =>
                                                        setFieldValue("effectiveToDate", date ? date.format("YYYY-MM-DD") : "")
                                                    }
                                                    getPopupContainer={(trigger) =>
                                                        (trigger.parentNode as HTMLElement) || document.body
                                                    }
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                    < div className="d-flex flex-row justify-content-center">
                                        <button
                                            type="submit"
                                            className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                        >
                                            {props.actionType === ACTION_TYPE.ADD_ACTION
                                                ? "Save"
                                                : "Update"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                            onClick={handleClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                href={`/templates/${props.reportName === REPORT_NAME.VALUE_CHAIN ? 'VALUE_CHAIN'
                                    : props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ? 'VALUE_CHAIN_CATEGORY'
                                        : props.reportName === REPORT_NAME.RESPONSIBILITY_GROUP ? 'RESPONSIBILITY_GROUP'
                                            : props.reportName === REPORT_NAME.RESPONSIBILITY_CENTER ? 'RESPONSIBILITY_CENTER'
                                                : props.reportName === REPORT_NAME.TOKEN_MECHANISM_MASTER ? 'TOKEN_MECHANISM_MASTER'
                                                    : ''}.xlsx`}

                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );

};

export default MasterReportData